{
  "top-salons-city-page": {
    "text": {
      "no-salon-found": "In dieser Stadt wurden noch keine Salons gefunden."
    },
    "meta": {
      "title": "Top Salons in {{ city }}",
      "description": "Entdecke und buche die bestbewerteten Beauty-Salons in {{ city }}. Vergleiche Top-Salons, prüfe die Verfügbarkeit und buche deinen Termin online in wenigen Minuten."
    }
  }
}
